import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import AudienceSelector from "@/components/site/AudienceSelector";
import ValuePillars from "@/components/site/ValuePillars";
import BuyerSellerFlow from "@/components/site/BuyerSellerFlow";
import BrokerSection from "@/components/site/BrokerSection";
import SupplierSection from "@/components/site/SupplierSection";
import HowItWorks from "@/components/site/HowItWorks";
import PaymentsSection from "@/components/site/PaymentsSection";
import AiHouseSection from "@/components/site/AiHouseSection";
import TrustBlock from "@/components/site/TrustBlock";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import CtaBand from "@/components/site/CtaBand";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import { scrollToHash } from "@/lib/scrollToHash";
import { useSeo, ORG_SCHEMA, SOFTWARE_SCHEMA, WEBSITE_SCHEMA, PRODUCT_OFFER_SCHEMA, buildFaqSchema } from "@/lib/seo";

const HashScroller = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => scrollToHash(hash), 50);
  }, [hash]);
  return null;
};

const SeoBinder = () => {
  const { lang, t } = useLang();
  useSeo(lang, {
    title: lang === "nl"
      ? "Tribeo | Marketplace voor makelaars en leveranciers"
      : "Tribeo | Marketplace for real estate agents and vendors",
    description: lang === "nl"
      ? "Eigen marketplace voor makelaars, gratis webshop voor leveranciers en één plek voor kopers, verkopers en eigenaren. Geen abonnement, geen opstartkosten."
      : "A branded marketplace for real estate agents, a free webshop for vendors, and one place for buyers, sellers and owners. No subscription, no setup costs.",
    ogTitle: lang === "nl"
      ? "Eén platform voor makelaars, leveranciers en hun klanten"
      : "One platform for agents, vendors and their clients",
    ogDescription: lang === "nl"
      ? "Bouw als makelaar je eigen marketplace, groei als leverancier via vertrouwde makelaars, en regel als klant alles rond je woning op één plek. Gratis te starten."
      : "Agents build their own marketplace, vendors grow through trusted agents, and clients manage everything around their home in one place. Free to start.",
    keywords: lang === "nl"
      ? "marketplace voor makelaars, software voor makelaars, woningdiensten platform, gratis webshop hovenier, woningonderhoud platform, AI woonadvies, kopers en verkopers, makelaar extra omzet"
      : "marketplace for real estate agents, real estate agent software, home services platform, free webshop vendors, property maintenance platform, AI home advice, homebuyers and sellers, agent extra revenue",
    nlPath: "/",
    enPath: "/en",
    jsonLd: [ORG_SCHEMA, WEBSITE_SCHEMA, SOFTWARE_SCHEMA, PRODUCT_OFFER_SCHEMA, buildFaqSchema(t.faq.items)],
  });
  return null;
};

const Index = () => {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-background">
        <HashScroller />
        <SeoBinder />
        <Header />
        <main>
          <Hero />
          <AudienceSelector />
          <ValuePillars />
          <BuyerSellerFlow />
          <BrokerSection />
          <SupplierSection />
          <HowItWorks />
          <PaymentsSection />
          <AiHouseSection />
          <TrustBlock />
          <Pricing />
          <FAQ />
          <CtaBand />
        </main>
        <Footer />
      <CookieBanner />
      </div>
    </LanguageProvider>
  );
};

export default Index;
